<div class="wrapper" id="divWrapper">
    <div class="content">
      <div class="main-new">
          <div class="container">
              <div class="block-page-card-new">
                  <div class="block-page-card-new-title">
                      <h1 [innerHTML]="'auth.welcome-coindepo-defi' | translate"></h1>
                  </div> <!-- .block-page-card-new-title -->

                  <div class="block-page-card-new-content">
                        <app-referal-modal class="modal-defi"></app-referal-modal>
                  </div> <!-- .block-page-card-new-content -->

              </div> <!-- .block-page-card-new -->
          </div> <!-- .container -->
      </div> <!-- .main-new --> 
    </div><!-- .content -->
  
    <div class="footer">
        <div class="container">
            <div class="footer-new-defi">
              <div class="social-block">
                  <ul class="social-list">						
                      <li>
                          <a rel="nofollow" href="https://twitter.com/DepoCoin" target="_blank"><i class="icomoonx iconx-x-logo"></i></a>
                      </li>
                      <li>
                          <a rel="nofollow" href="https://www.instagram.com/coindepo_official/" target="_blank"><i class="icomoonsocial icomoonsocial-instagram"></i></a>
                      </li>
                      <li>
                          <a rel="nofollow" href="https://www.youtube.com/@CoinDepo_SmartProfit" target="_blank"><i class="icomoonsocial icomoonsocial-youtube"></i></a>
                      </li>
                      <li>
                          <a rel="nofollow" href="https://medium.com/@coindepo" target="_blank"><i class="icomoonsocial icomoonsocial-medium"></i></a>
                      </li>										
                      <li>
                          <a rel="nofollow" href="https://t.me/coin_depo" target="_blank"><i class="icomoonsocial icomoonsocial-telegram"></i></a>
                      </li>
                      <li>
                          <a rel="nofollow" href="https://discord.gg/4zBm8YDJ" target="_blank"><i class="icomoondiscordgrey icomoondiscordgrey-new"></i></a>
                      </li>

                  </ul>
              </div><!-- .social-block --> 
              
                <div class="copyright-defi">
                    <p class="copyright">                 
                        © 2021-{{ year }} CoinDepo.
                        <span class="white-space-nowrap">{{
                        'footer.rights-reserved' | translate
                        }}</span>
                    </p>
                    <ul class="footer-nav">
                        <li>
                            <a [href]="'footer.terms&conditions-href' | translate" target="_blank">{{
                                 'footer.terms&conditions' | translate
                                }}</a>
                        </li>
                        <li>
                            <a [href]="'footer.privacy-policy-href' | translate" target="_blank">{{
                                'footer.privacy-policy' | translate
                                }}</a>
                        </li>
                        <li>
                            <a [href]="'footer.help-center-href' | translate" target="_blank">{{
                                'footer.help-center' | translate
                                }}</a>
                        </li>
                        <li>
                            <input type="hidden" name="hdnLanguagefooter" id="hdnLanguagefooter" value="">
                          <div class="dropdown language-dropdown-footer" id="dropdownLanguagefooter" data-id="dropdownLanguagefooter">
                            <a class="dropdown-toggle" type="button" id="Languagefooter" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <span> {{ 'footer.language' | translate }} </span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-lender" aria-labelledby="Language">
                                <div class="scroll-height mCustomScrollbar _mCS_1 mCS_no_scrollbar"><div id="mCSB_1" class="mCustomScrollBox mCS-dark-thin mCSB_vertical mCSB_inside" style="max-height: none;" tabindex="0"><div id="mCSB_1_container" class="mCSB_container mCS_y_hidden mCS_no_scrollbar_y" style="position:relative; top:0; left:0;" dir="ltr">
                                  <span class="dropdown-item dropdown-item-lender active" data-status="1">
                                      <div class="media media-table">
                                          <div class="media-body" (click)="changeLang('en')">
                                              <a class="cursor-pointer" [class.active]="(currentLang$ | async) === 'en'">English</a>

                                          </div>
                                      </div>						    	
                                  </span>
                                  <span class="dropdown-item dropdown-item-lender" data-status="2" *ngIf="!isProd">
                                      <div class="media media-table">
                                          <div class="media-body" (click)="changeLang('de')">
                                              <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'de'">Deutsch</a>

                                          </div>
                                      </div>						    	
                                  </span>
                                  <span class="dropdown-item dropdown-item-lender" data-status="3" *ngIf="!isProd">
                                      <div class="media media-table">
                                          <div class="media-body" (click)="changeLang('es')">
                                              <a class="cursor-pointer" [class.active]="(currentLang$ | async) === 'es'">Español (International)</a>
 
                                          </div>
                                      </div>						    	
                                  </span>
                                  <span class="dropdown-item dropdown-item-lender" data-status="4" *ngIf="!isProd">
                                      <div class="media media-table">
                                          <div class="media-body" (click)="changeLang('es-419')">
                                              <a class="cursor-pointer" [class.active]="(currentLang$ | async) === 'es-419'">Español (Latinoamérica)</a>

                                          </div>
                                      </div>						    	
                                  </span>
                                  <span class="dropdown-item dropdown-item-lender" data-status="5" *ngIf="!isProd">
                                      <div class="media media-table">
                                          <div class="media-body" (click)="changeLang('fr')">
                                              <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'fr'">Français</a>

                                          </div>
                                      </div>						    	
                                  </span>
                                  <span class="dropdown-item dropdown-item-lender" data-status="6" *ngIf="!isProd">
                                      <div class="media media-table">
                                          <div class="media-body" (click)="changeLang('it')">
                                              <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'it'">Italiano</a>

                                          </div>
                                      </div>						    	
                                  </span>
                                  <span class="dropdown-item dropdown-item-lender" data-status="7" *ngIf="!isProd">
                                      <div class="media media-table">
                                          <div class="media-body" (click)="changeLang('pl')">
                                              <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'pl'">Polski</a>

                                          </div>
                                      </div>						    	
                                  </span>
                                  <span class="dropdown-item dropdown-item-lender" data-status="8" *ngIf="!isProd">
                                      <div class="media media-table">
                                          <div class="media-body" (click)="changeLang('pt')">
                                              <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'pt'">Português</a>

                                          </div>
                                      </div>						    	
                                  </span>
                                  <span class="dropdown-item dropdown-item-lender" data-status="9" *ngIf="!isProd">
                                      <div class="media media-table">
                                          <div class="media-body" (click)="changeLang('ru')">
                                              <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'ru'">Русский</a>

                                          </div>
                                      </div>						    	
                                  </span>
                                  <span class="dropdown-item dropdown-item-lender" data-status="10" *ngIf="!isProd">
                                    <div class="media media-table">
                                        <div class="media-body" (click)="changeLang('vi')">
                                            <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'vi'">Tiếng Việt</a>

                                        </div>
                                    </div>						    	
                                </span>
                                  <span class="dropdown-item dropdown-item-lender" data-status="11" *ngIf="!isProd">
                                      <div class="media media-table">
                                          <div class="media-body" (click)="changeLang('tr')">
                                              <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'tr'">Türkçe</a>

                                          </div>
                                      </div>						    	
                                  </span>
                                  <span class="dropdown-item dropdown-item-lender" data-status="12" *ngIf="!isProd">
                                      <div class="media media-table">
                                          <div class="media-body" (click)="changeLang('uk')">
                                              <a class="cursor-pointer"  [class.active]="(currentLang$ | async) === 'uk'">Українська</a>

                                          </div>
                                      </div>						    	
                                  </span>

                                </div><div id="mCSB_1_scrollbar_vertical" class="mCSB_scrollTools mCSB_1_scrollbar mCS-dark-thin mCSB_scrollTools_vertical" style="display: none;"><div class="mCSB_draggerContainer"><div id="mCSB_1_dragger_vertical" class="mCSB_dragger" style="position: absolute; min-height: 30px; top: 0px;"><div class="mCSB_dragger_bar" style="line-height: 30px;"></div></div><div class="mCSB_draggerRail"></div></div></div></div></div>
                            </div>
                          </div><!-- //language-dropdown-footer -->
                        </li>
                    </ul>	
                </div> <!-- .copyright-defi -->	
            </div> <!--  footer-new-defi -->

        </div> <!-- .container -->

    </div>

</div>